import { render, staticRenderFns } from "./consignmenthubinscan.vue?vue&type=template&id=7b5d5920&"
import script from "./consignmenthubinscan.vue?vue&type=script&lang=js&"
export * from "./consignmenthubinscan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports